import {
    NgModule,
    CUSTOM_ELEMENTS_SCHEMA
} from '@angular/core';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { TooltipModule } from "ngx-tooltip";


//  Components
import { SpinnerComponent } from './components/spinner/spinner.component';
import { TileComponent } from './components/tile/tile.component';
import { FlexibleDropdownComponent } from './components/flexible-dropdown/flexible-dropdown.component';

//  Pipes
import { ISOToDatePipe } from './pipes/iso-to-date.pipe';
import { FormatStringPipe } from './pipes/format-string.pipe';
import { FormErrorPipe } from './pipes/form-error.pipe';

import { ReactiveInputComponent } from './components/reactive-input/reactive-input.component';
import { ItpxValidators } from './validators/itpx-validators';
import {TranslatePipe} from './pipes/translate.pipe';
import {ModalComponent} from './components/modal/modal.component';
import {SimpleInfoComponent} from './components/modal/simple-info.component';
import {SimpleAlertComponent} from './components/modal/simple-alert.component';
import { ComponentDirective } from 'app/shared/components/modal/component.directive';
import {CertificatePreviewComponent} from '../core/components/content/certificate/preview/certificate-preview.component';
import {EscapeHtmlPipe} from './pipes/keep-html.pipe';
import {ISOToDateSimplePipe} from './pipes/iso-to-simpledate.pipe';
import {PrivacyPolicyModalComponent} from './components/modal/privacy-policy-modal.component';
import {ContentUpdatedInfoComponent} from './components/modal/content-updated-info.component';
import {SafeUrlPipe} from './pipes/safe-url.pipe';
import { HappyCheckboxControlComponent } from './components/happy/happy-checkbox-control/happy-checkbox-control.component';
import { HappyControlGroupInputComponent } from './components/happy/happy-control-group/happy-control-group-input.component';
import { HappyDetailsGroupComponent } from './components/happy/happy-details-group/happy-details-group.component';
import { HappyDropdownComponent } from './components/happy/happy-dropdown/happy-dropdown.component';
import { HappyHeadingComponent } from './components/happy/happy-heading/happy-heading.component';
import { HappyListComponent } from './components/happy/happy-list/happy-list.component';
import { HappyRadioInputComponent } from './components/happy/happy-radio-input/happy-radio-input.component';
import { HappySelectInputComponent } from './components/happy/happy-select-input/happy-select-input.component';
import { HappyTextInputComponent } from './components/happy/happy-text-input/happy-text-input.component';
import { HappyTextareaInputComponent } from './components/happy/happy-textarea-input/happy-textarea-input.component';
import { HappyInputTemplateComponent } from './components/happy/happy-template-input/happy-input-template.component';
import { TranslateHandlebarsPipe } from './pipes/translate-handlebars.pipe';
import { BreadcrumbsComponent } from './components/breadcrumbs/breadcrumbs.component';
import { ShiftDatePipe } from './pipes/shift-date.pipe';
import { SimpleInfoEdcastComponent } from './components/modal/simple-info-edcast/simple-info-edcast.component';
import { ContentUpdatedInfoEdcastComponent } from './components/modal/content-updated-info-edcast/content-updated-info-edcast.component';
import { AddClassOnMouseover } from 'app/shared/components/addClassOnMouseOver';
import { RateProductComponent } from './components/modal/rate-product/rate-product.component';
import { StarRatingComponent } from './components/star-rating/star-rating.component';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        TooltipModule
    ],
    declarations: [
        SpinnerComponent,
        TileComponent,
        FlexibleDropdownComponent,
        ModalComponent,
        ISOToDatePipe,
        ISOToDateSimplePipe,
        FormatStringPipe,
        FormErrorPipe,
        ReactiveInputComponent,
        TranslatePipe,
        TranslateHandlebarsPipe,
        SimpleInfoComponent,
        SimpleAlertComponent,
        PrivacyPolicyModalComponent,
        ContentUpdatedInfoComponent,
        CertificatePreviewComponent,
        ComponentDirective,
        EscapeHtmlPipe,
        SafeUrlPipe,
        HappyCheckboxControlComponent,
        HappyControlGroupInputComponent,
        HappyDetailsGroupComponent,
        HappyDropdownComponent,
        HappyHeadingComponent,
        HappyListComponent,
        HappyRadioInputComponent,
        HappySelectInputComponent,
        HappyTextInputComponent,
        HappyTextareaInputComponent,
        HappyInputTemplateComponent,
        BreadcrumbsComponent,
        ShiftDatePipe,
        SimpleInfoEdcastComponent,
        ContentUpdatedInfoEdcastComponent,
        AddClassOnMouseover,
        RateProductComponent,
        StarRatingComponent
    ],
    providers: [
        ItpxValidators,
        TranslatePipe,
        TranslateHandlebarsPipe,
        BreadcrumbsComponent

    ],
    exports: [
        SpinnerComponent,
        TileComponent,
        FlexibleDropdownComponent,
        ReactiveInputComponent,
        ISOToDatePipe,
        ISOToDateSimplePipe,
        FormatStringPipe,
        FormErrorPipe,
        TranslatePipe,
        TranslateHandlebarsPipe,
        ModalComponent,
        EscapeHtmlPipe,
        SafeUrlPipe,
        ShiftDatePipe,
        HappyCheckboxControlComponent,
        HappyControlGroupInputComponent,
        HappyDetailsGroupComponent,
        HappyDropdownComponent,
        HappyHeadingComponent,
        HappyListComponent,
        HappyRadioInputComponent,
        HappySelectInputComponent,
        HappyTextInputComponent,
        HappyTextareaInputComponent,
        HappyInputTemplateComponent,
        BreadcrumbsComponent,
        AddClassOnMouseover
    ],
    entryComponents: [
      SimpleInfoComponent,
      SimpleAlertComponent,
      PrivacyPolicyModalComponent,
      ContentUpdatedInfoComponent,
      CertificatePreviewComponent,
      SimpleInfoEdcastComponent,
      ContentUpdatedInfoEdcastComponent,
      RateProductComponent
    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA
    ]
})

export class SharedModule { }



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts